
import {get, getAll } from '../src/module/veronicaview';
import GLightbox from 'glightbox';
////////////////////bootstrap styls
///////////////////////////////////////////////////////////////////////
/////////////////////////import flatpickr datepicker///////////////////
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
////////////////////////////////////////////////////////////////
////import swiper////////////////////////////////
import Swiper, { Navigation, Pagination } from 'swiper';

// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import {Tooltip} from 'bootstrap';
////////////////////////////////////////////////////////////////
///////////////////import AOS js amination////////////////////////////////
// import AOS from 'aos';
// import 'aos/dist/aos.css'; // You can also use <link> for styles
// 
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
})
// AOS.init();
////////////////////////impor formulario script//////////////
import Formulario from '../src/module/Form'
import'../src/module/boo-now-tours.js'
import'../src/module/contac_us'
Formulario();
//////////////////////////////////////////////////////////////////////
//////////////////////flicker plugin////////////////////////////////
var check_in;
flatpickr("#check_in", {
    enableTime: false,
    allowInput: true,
    disableMobile: "true",
    // altInput: true,
    minDate: "today",
    dateFormat: "Y/m/d ",
    onChange: (selectedDates, dateStr, instance) => {
        check_out(dateStr);
    },
});

function check_out(e) {
    flatpickr("#check_out", {
        enableTime: false,
        allowInput: true,
        disableMobile: "true",
        // altInput: true,
        minDate: e ? e : "today",
        dateFormat: "Y/m/d ",
    });
}
check_out();

////////////////////////////////////////////////////////////////
////////////////////// librari slider swiper plugin//////////////////////////////////////////
////////////sider home////////////////////

    var swiper = new Swiper('.swiper-container', {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: true,
        },
        breakpoints: {
            1181: {
                slidesPerView: 3
            },
            1180: {
                slidesPerView: 3
            },
            1020: {
                slidesPerView: 2
            },
            700: {
                slidesPerView: 1
            },
            360: {
                slidesPerView: 1
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }

    });

    var swiperhome = new Swiper(".mySwipers", {
        modules: [Pagination],
        // direction: "vertical",
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
      var swiperRoom = new Swiper(".swiper-containers", {
        modules: [Navigation],
        // direction: "vertical",
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
      });





////////////////////////////// rom script///////////////////////////////////////
var lang = document.querySelector("meta[property='og:locale']").getAttribute("content");
const a = document.querySelectorAll('.show-vv__');
for (let index = 0; index < a.length; index++) {
    const elemet = a[index];
    elemet.addEventListener('click', function() {
        let b = elemet.previousSibling.previousSibling;
        if (b.getAttribute('data') == 'show') {
            if (lang == 'en_US') {
                elemet.innerHTML = 'Read Less';
            } else {
                elemet.innerHTML = 'Leer Menos';
            }
            b.style.transition = "all 2s"
            b.style.display = "block";
            b.setAttribute("data", 'hide');

        } else {
            if (lang == 'en_US') {
                elemet.innerHTML = 'Read More';
            } else {
                elemet.innerHTML = 'Leer Mas';
            }

            b.style.display = "-webkit-box";
            b.setAttribute("data", 'show');
        }
    });

};
// import app js
import app from '/app';
// // Init glightbox
const lightbox = GLightbox({
    selector:'.glightbox2',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});